export default {"src":"/_next/static/media/LinkedIn.d5a4ba11.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};